var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useNavigate } from "@madmedical/routing";
import { useCallback } from "react";
import useGeneratePath from "./useGeneratePath";
export default () => {
    const baseNavigate = useNavigate();
    const generatePath = useGeneratePath();
    const navigate = useCallback((route, params, options = {}) => {
        const { search } = options, restOptions = __rest(options, ["search"]);
        baseNavigate(generatePath(route, params, search), restOptions);
    }, [baseNavigate, generatePath]);
    return navigate;
};
